import { render, staticRenderFns } from "./Uec.vue?vue&type=template&id=d4b0a182"
import script from "./Uec.vue?vue&type=script&lang=ts"
export * from "./Uec.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports